import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Loader from "../../../components/ui/Loader/Loader";
import HttpAPICall from "../../../services/HttpAPICall";
import { INVENTORY_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import { DisplayListPagination } from "../../../components/TapUi";
import NumberFormatter from "../../../services/NumberFormater";
import DateService from "../../../services/DateService";
import { Link } from "react-router-dom";
import PurchaseOrderDetailModal from "./PurchaseOrderDetailModal";

const POHistoryContentModal = ({ itemData, warehouse_id, indent_transaction_id = '', req_item_id = '', onLogisticClick }) => {
    const poDetailModalRef = useRef(null);
    const [poDetailList, setPoDetailList] = useState([]);
    const [poDetailLoading, setPoDetailLoading] = useState(false);
    const [itemName, setItemName] = useState("");
    const [listing_tbl_page, setListingTblPage] = useState(1);
    const [listingMeta, setListingMeta] = useState(null);
    const [totalListingCount, setTotalListingCount] = useState(0);

    const access_token = useSelector(state => state.auth.access_token);
    const permissions = useSelector(state => state.app.acl_info?.permissions || []);

    const poReportUrl = INVENTORY_API_BASE_URL_2 + '/report/item-wise-purchase-order';
    const poView = permissions.includes('isc-po-view');

    const fetchPOHistoryData = (page = 1) => {
        setPoDetailLoading(true);
        setPoDetailList([]);
        setListingTblPage(page);

        let params = {
            search_warehouse_ids: warehouse_id ? [warehouse_id] : [],
            search_item_ids: itemData ? [itemData.id] : null,
            indent_transaction_id: indent_transaction_id,
            req_item_id: req_item_id,
            page: page
        };

        HttpAPICall.withAthorization('GET', poReportUrl, access_token, { ...params }, {}, (resp) => {
            let respData = resp.data;
            setPoDetailList(respData.data);
            setItemName(itemData ? itemData.name : '');
            setListingMeta(respData);
            setTotalListingCount(respData.total);
        }).finally(() => setPoDetailLoading(false));
    };

    const handlePODetailClick = (transaction_id) => {
        if (poDetailModalRef.current) {
            poDetailModalRef.current.modalPOInit(transaction_id);
        }
    };

    useEffect(() => {
        if (itemData) {
            fetchPOHistoryData();
        }
    }, [itemData, warehouse_id, indent_transaction_id, req_item_id]);

    if (poDetailLoading) return <Loader />;

    return (
        <>
        <div>
            <div className='p-1 bg-light border-bottom mb-3'>
                <table className='table table-sm mb-0 table-borderless text-sm'>
                    <tbody>
                        {indent_transaction_id ? (
                            <tr>
                                <td style={{ width: "15%" }}>Indent</td>
                                <th>{indent_transaction_id}</th>
                            </tr>
                        ) : (
                            <tr>
                                <td style={{ width: "15%" }}>Warehouse</td>
                                <th>{poDetailList.length > 0 && poDetailList[0]?.warehouse_name ? `${poDetailList[0]?.warehouse_name}` : "-"}</th>
                            </tr>
                        )}
                        <tr>
                            <td style={{ width: "15%" }}>Item</td>
                            <th>{itemName || "-"}</th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style={{ maxHeight: "330px", overflowY: "auto", marginTop: "8px", marginBottom: "8px" }}>
                <table className="table table-bordered bg-white table-fixed">
                    <thead className="table-secondary">
                        <tr className="text-end">
                            <th scope="col" style={{ width: "13%" }} className="text-start">PO Number</th>
                            <th scope="col" style={{ width: "8%" }} className="text-center">PO Date</th>
                            {poView && (
                                <th scope="col" style={{ width: "10%" }} className="text-start">Vendor Name</th>
                            )}
                            {indent_transaction_id && (
                                <th scope="col" style={{ width: "10%" }} className="text-start">Warehouse</th>
                            )}
                            <th scope="col" style={{ width: "8%" }}>Total Qty</th>
                            {poView && (
                                <>
                                    <th scope="col" style={{ width: "8%" }}>Unit Rate</th>
                                    <th scope="col" style={{ width: "6%" }}>Amount</th>
                                </>
                            )}
                            <th scope="col" style={{ width: "10%" }}>Pending Qty</th>
                            <th scope="col" style={{ width: "8%" }}>Due Date</th>
                            <th scope="col" style={{ width: "10%" }}>Logistic Data</th>
                            <th scope="col" style={{ width: "6%" }} className='text-center'>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {poDetailList.length > 0 ? (
                            poDetailList.map((poi, k) => (
                                <tr key={k}>
                                    <td>
                                        {poView ? (
                                            <button
                                                className="link-primary cursor_pointer btn btn-link text-decoration-none"
                                                onClick={() => handlePODetailClick?.(poi.transaction_id)}
                                            >
                                                {poi.transaction_id}
                                            </button>
                                        ) : (
                                            <span>{poi.transaction_id}</span>
                                        )}
                                    </td>
                                    <td>{poi.transaction_date_display}</td>
                                    {poView && <td className='text-capitalize'>{poi.vendor_name}</td>}
                                    {indent_transaction_id && <td className='text-capitalize'>{poi.warehouse_name}</td>}
                                    <td className='text-end'>{poi.qty}</td>
                                    {poView && (
                                        <>
                                            <td className='text-end'><NumberFormatter number={poi.rate} precision={2} /></td>
                                            <td className='text-end'><NumberFormatter number={poi.qty * poi.rate} precision={2} /></td>
                                        </>
                                    )}
                                    <td className='text-end'>{poi.pending_qty}</td>
                                    <td className='text-end'>{poi.due_date_display ? poi.due_date_display : poi.expected_delivery_date_display ? poi.expected_delivery_date_display : ""}</td>
                                    <td className='text-center'>
                                        {poi.logistic_edd_data && poi.logistic_edd_data.length > 0 && poi.logistic_edd_data.map((d, idx) => (
                                            <div key={idx}>
                                                <Link onClick={() => onLogisticClick?.(d.transaction_id)}>
                                                    {d.transaction_id} (EDD : {d.delivery_date ? DateService.dateFormat(d.delivery_date) : 'NA'})
                                                </Link>
                                            </div>
                                        ))}
                                    </td>
                                    <td className='text-center'>{poi.status_name}</td>
                                </tr>
                            ))
                        ) : (
                            <tr><td className="text-center" colSpan={11}>No Record Found</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
            <DisplayListPagination
                meta={listingMeta}
                onPageChange={(e) => fetchPOHistoryData(e.selected + 1)}
            />
        </div>
         <PurchaseOrderDetailModal ref={poDetailModalRef} />
        </>
    );
};

export default POHistoryContentModal;